// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'D:/workspace/shilao-lease-super/node_modules/.pnpm/@umijs+renderer-react@4.6.2_a70914a4730113b7b9645ce162dd5d33/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
